import { render } from "./newLoginSignup.vue?vue&type=template&id=6a44ce42"
import script from "./newLoginSignup.vue?vue&type=script&lang=js"
export * from "./newLoginSignup.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__